import { render, staticRenderFns } from "./FaultList.vue?vue&type=template&id=61ab9c1b&scoped=true"
import script from "./FaultList.vue?vue&type=script&lang=js"
export * from "./FaultList.vue?vue&type=script&lang=js"
import style0 from "./FaultList.vue?vue&type=style&index=0&id=61ab9c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab9c1b",
  null
  
)

export default component.exports